export const isNonRetina = () => window.devicePixelRatio === 1

export const isSafari = () =>
	/^((?!chrome|android).)*safari/i.test(navigator.userAgent)

export const isSafariOnNonRetina = () => isSafari() && isNonRetina()
